/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_F1_TitleInputs */

const en_landing_features_f1_title = /** @type {(inputs: Landing_Features_F1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten passes, one picture`)
};

const zh_landing_features_f1_title = /** @type {(inputs: Landing_Features_F1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`改十轮，还是那张图`)
};

/**
* | output |
* | --- |
* | "Ten passes, one picture" |
*
* @param {Landing_Features_F1_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_f1_title = /** @type {((inputs?: Landing_Features_F1_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_F1_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_f1_title(inputs)
	return zh_landing_features_f1_title(inputs)
});
export { landing_features_f1_title as "landing.features.f1_title" }